import { useStatsAssetStatus } from "../../api/hooks/stats";

const WarehouseInventory = () => {
  const { data } = useStatsAssetStatus();
  return (
    <div className="flex flex-col gap-4 rounded-xl border-2 pb-4">
      <div className="flex gap-2 rounded-t-xl bg-[#D1DFFF] px-6 py-1 text-lg">
        <div>Warehouse Inventory</div>
      </div>
      <div className="flex flex-grow justify-between gap-6 divide-x px-16">
        <div className="flex-grow text-center">
          <p className="">To Be Inspected</p>
          <p className="">{data?.RETURNED || 0} Qty</p>
        </div>
        <div className="flex-grow text-center">
          <p className="">Inspected (RFU)</p>
          <p className="">{(data?.CLEANED || 0) + (data?.FIXED || 0)} Qty</p>
        </div>
      </div>
    </div>
  );
};

export default WarehouseInventory;
